var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"easter-egg"},[_c('img',{attrs:{"src":require("@/assets/Poing.png")}}),_c('BIcon',{staticClass:"close-easter-egg",attrs:{"icon":"x-circle-fill"},on:{"click":_vm.hideEasterEgg}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }